import { AlertTriangle } from "lucide-react";

export default function Safety() {
  return (
    <div className="max-w-3xl mx-auto px-5 md:px-8 py-14 md:py-20" data-testid="safety-page">
      <div className="flex items-center gap-2">
        <AlertTriangle className="w-5 h-5 text-terracotta-700" />
        <div className="overline">Safety & disclaimer</div>
      </div>
      <h1 className="font-display text-4xl text-teal-900 mt-2">Surfmatics is a planning aid.</h1>
      <p className="mt-5 text-teal-900 leading-relaxed">
        Ocean conditions change rapidly. Forecasts and community reports may be inaccurate. Users
        must assess conditions on arrival and follow lifeguard and official advice. Surfmatics does
        not guarantee that any location is safe.
      </p>
      <ul className="mt-6 space-y-2 text-teal-900">
        <li>· Beginners should surf between lifeguarded flags where possible.</li>
        <li>· Consider a lesson at unfamiliar locations.</li>
        <li>· Tide data shown during development is a deterministic estimate, not a live tide forecast.</li>
        <li>· Business listings are not endorsements unless explicitly labelled.</li>
      </ul>
    </div>
  );
}
